//This is the main root componets..(we write code and here we render the code written in app )

import React from "react";
import ReactDOM from "react-dom";
import "./nav.css";
import App from "./App.js";

ReactDOM.render(<App />, document.getElementById("root"));
